import React from 'react'
import SnackbarContext from 'contexts/Snackbar/context'

export default function useSnackbar() {
  const context = React.useContext(SnackbarContext)
  if (context === undefined) {
    throw new Error(`SnackbarContext must be used within a SnackbarProvider`)
  }
  return context
}
